export const ATTRIBUTE_TYPES = {
  SELECT: 'SELECT',
  INTEGER: 'INTEGER',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  MULTISELECT: 'MULTISELECT',
  TEXT: 'TEXT',
  CHECKBOX: 'CHECKBOX',
  TIMESTAMP: 'TIMESTAMP',
  STRUCTURE: 'STRUCTURE',
} as const;

/**
 * Тип атрибута (назначение)
 */
export const ATTRIBUTE_KINDS = {
  SYSTEM: 'SYSTEM',
  COMPUTED_TRANSCRIBATION: 'COMPUTED_TRANSCRIBATION',
  COMPUTED_RAW: 'COMPUTED_RAW',
  EXPERT_REPORT_RATING: 'EXPERT_REPORT_RATING',
  ANALYTICS: 'ANALYTICS',
} as const;

/**
 * Display format for numeric attribute values
 * SECOND - display as time duration (e.g., "1h 30m 45s")
 * PERCENT - display as percentage (e.g., "85.5%")
 */
export const DISPLAY_FORMATS = {
  SECOND: 'SECOND',
  PERCENT: 'PERCENT',
} as const;

/**
 * Attribute types that support displayFormat
 */
export const DISPLAY_FORMAT_TYPES = [ATTRIBUTE_TYPES.INTEGER, ATTRIBUTE_TYPES.DECIMAL] as const;

/**
 * Type for attributes that support displayFormat
 */
export type DisplayFormatType = (typeof DISPLAY_FORMAT_TYPES)[number];
